import { render, staticRenderFns } from "./BulkCollectionForm.vue?vue&type=template&id=6b08d45e"
import script from "./BulkCollectionForm.vue?vue&type=script&lang=js"
export * from "./BulkCollectionForm.vue?vue&type=script&lang=js"
import style0 from "./BulkCollectionForm.vue?vue&type=style&index=0&id=6b08d45e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports